export default __webpack_public_path__ + "static/media/hero-thumb-1.77bb531a.png";